/* eslint-disable react/button-has-type */
import { FC } from "react";
import { useAppSelector } from "@wff/store/hooks";
import classes from "./Button.module.scss";

interface Props {
  className?: string;
  type?: "submit" | "reset" | "button";
  value?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  restProps?: Object;
}

export const Button: FC<Props & React.HTMLProps<HTMLButtonElement>> = ({
  children,
  className,
  type,
  value,
  disabled = false,
  onClick,
  ...restProps
}) => {
  const { languageCode } = useAppSelector((state) => state.locale);
  let styles = {};
  if (languageCode !== "en-CA" && languageCode !== "fr-CA") {
    styles = { borderRadius: 0 }; // squared corners for US, rounded for CA
  } else {
    styles = { borderRadius: "10rem" }; // squared corners for US, rounded for CA
  }
  if ((restProps as any)?.style) {
    styles = { ...styles, ...(restProps as any).style }; // overrides
  }

  return (
    <button
      className={`${classes.btn} ${className}`}
      value={value}
      type={type}
      disabled={disabled}
      onClick={onClick}
      {...restProps}
      style={{ ...styles }}
    >
      {children}
    </button>
  );
};

Button.defaultProps = {
  className: "",
  type: "button",
  onClick: undefined,
};
